<template>
  <div class="place padding_20">
    <el-form ref="form"
             :rules="rules"
             :model="form"
             label-width="80px">
      <el-form-item label="场名称" class="form__item--input" prop="name">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item label="客户" prop="site_id">
        <searchSite v-model="form.site_id"/>
      </el-form-item>
      <el-form-item label="group" prop="group_id">
        <template>
          <el-select
            v-model="form.group_id"
            filterable
            allow-create
            default-first-option
            multiple
            clearable
            placeholder="可选择或输入">
            <el-option
              v-for="item in groupOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="备注" class="form__item--textarea" prop="desc">
        <el-input type="textarea" v-model.trim="form.desc"></el-input>
      </el-form-item>
      <el-form-item v-if="form.id" label="操作">
        <el-button size="mini" type="primary" @click="maptrans('data')">旧场SVG数据转编辑器数据</el-button>
        <el-button size="mini" type="primary" @click="maptrans(0)">SVG转BMAP</el-button>
        <el-button size="mini" type="primary" @click="maptrans(1)">编辑器数据转BMAP</el-button>
      </el-form-item>
      <el-form-item label="楼层信息">
        <el-table
          class="table"
          :data="filterFloors">
          <el-table-column
            label="楼层顺序"
            prop="sort_index"
            width="100">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="floor"
            label="id"
            width="80">
            <template slot-scope="scope">
              <span>{{scope.row.id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="floor"
            label="楼层"
            width="80">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.floor" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.floor}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            width="160">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.name" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_floor"
            label="是否楼层"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.is_floor"
                           size="mini"
                           v-if="scope.row.editable"
                           :true-label="1"
                           :false-label="0"></el-checkbox>
              <span v-else>{{scope.row.is_floor === 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="belong_to_floor"
            label="所属楼层"
            width="160">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.belong_to_floor" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.belong_to_floor}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="height"
            label="层高(m)"
            width="100">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.height" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.height}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            width="100">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type"
                         size="mini"
                         v-if="scope.row.editable"
                         style="width:80px">
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{typeList.filter(item => (item.value === scope.row.type)).pop().name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="theta"
            label="方向角(°)"
            width="80">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.theta"
                v-if="scope.row.editable"
                size="mini"
                @change="val => handleInputFloat(scope.row, 'theta', val)"></el-input>
              <span v-else>{{scope.row.theta}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="north"
            label="指北角(°)"
            width="80">
            <template slot-scope="scope">
              <el-input
                v-model.trim="scope.row.north"
                v-if="scope.row.editable"
                size="mini"
                @change="val => handleInputFloat(scope.row, 'north', val)"></el-input>
              <span v-else>{{scope.row.north}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="label3d_display_status"
            label="是否显示3d标签"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.label3d_display_status"
                           size="mini"
                           v-if="scope.row.editable"
                           :true-label="1"
                           :false-label="0"></el-checkbox>
              <span v-else>{{scope.row.label3d_display_status === 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_outdoor"
            label="是否室外"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.is_outdoor"
                           size="mini"
                           v-if="scope.row.editable"
                           :true-label="1"
                           :false-label="0"></el-checkbox>
              <span v-else>{{scope.row.is_outdoor === 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="mesh_id"
            label="mesh模型"
            width="180">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.mesh_id" size="mini" v-if="scope.row.editable"></el-input>
              <span class="mesh_id" v-else>{{scope.row.mesh_id}}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="guide_vr_id" label="guide_vr_id" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.guide_vr_id" size="mini" v-if="scope.row.editable"></el-input>
              <span class="guide_vr_id" v-else>{{ scope.row.guide_vr_id }}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="vr_id" label="vr_id" width="120">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.vr_id" size="mini" v-if="scope.row.editable"></el-input>
              <span class="vr_id" v-else>{{ scope.row.vr_id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="floor_3dmap"
            label="透视投影图"
            width="180">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.floor_3dmap"
                style="width: 100px; height: 100px"
                :src="scope.row.floor_3dmap"
                fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="floor_2dmap"
            label="二维平面图"
            width="180">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.floor_2dmap"
                style="width: 100px; height: 100px"
                :src="scope.row.floor_2dmap"
                fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="floor_cmap"
            label="C端地图"
            width="180">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.floor_cmap"
                style="width: 100px; height: 100px"
                :src="scope.row.floor_cmap"
                fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="and_map"
            label="舆地图"
            width="180">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.and_map"
                style="width: 100px; height: 100px"
                :src="scope.row.and_map"
                fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="parking_floor_name"
            label="停车场楼层名"
            width="180">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.parking_floor_name" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.parking_floor_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="parking_site_id"
            label="停车场site_id"
            width="180">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.parking_site_id" size="mini" v-if="scope.row.editable"></el-input>
              <span v-else>{{scope.row.parking_site_id}}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="right"
            min-width="260">
            <template slot="header" slot-scope="scope">
              <el-button
                size="mini"
                @click="handleInsert(scope.row)">新 增</el-button>
              <el-popover
                placement="bottom"
                width="280"
                trigger="click">
                <div style="margin-bottom: 10px">使用后需手动同步对齐参数</div>
                <el-select size="mini"
                           v-model="sourcePlaceId"
                           filterable
                           clearable>
                  <el-option
                    v-for="(item, index) in places"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-button size="mini"
                           type="primary"
                           style="margin-left: 20px"
                           @click="handleCopy()">确 定</el-button>
                <el-button slot="reference" size="mini" style="margin-left: 20px">复 制</el-button>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-switch
                class="table__item--switch"
                v-model="scope.row.editable">
              </el-switch>
              <el-button
                class="table__item--btn"
                size="mini"
                type="danger"
                :disabled="!scope.row.editable"
                @click="handleDelete(scope.$index, scope.row)">删 除</el-button>
              <el-button
                class="table__item--btn"
                size="mini"
                :disabled="!scope.row.editable"
                @click="handleUpdateVR(scope.$index, scope.row)">更新店铺视角</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">提 交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Sortable from 'sortablejs';
import Axios from 'axios';
import searchSite from '@/components/searchSite/index.vue';
import {
  bulkCreatePlace,
  getPlace,
  getAllFloors,
  fetchplaceList,
  getPlacesInfo,
  updateVR,
  getGroupList,
  getGroupIdByPlaceId,
  createGroup,
  updateGroup,
  syncFloorAndSite,
} from '@/api/place';

export default {
  components: {
    searchSite,
  },
  data() {
    return {
      places: [],
      sourcePlaceId: null,
      form: {
        id: this.$route.query.id,
        name: '',
        site_id: '',
        group_id: [],
        desc: '',
        floors: [],
      },
      groupOptions: [],
      floor: {
        sort_index: null, // 序号，不展示
        floor: '', // 楼层
        name: '', // 名称
        mesh_id: '', // mesh模型
        floor_3dmap: '', // 透视投影图
        floor_2dmap: '', // 2D平面图
        floor_cmap: '',
        height: null, // 层高
        theta: null,
        north: null,
        label3d_display_status: 0,
        is_outdoor: 0,
        type: 0, // 类型
        is_delete: 0,
        is_floor: 1,
        belong_to_floor: '',
        parking_floor_name: '',
        parking_site_id: '',
      },
      loading: false,
      rules: {
        name: [
          { required: true, message: '请输入场名称', trigger: 'blur' },
        ],
        site_id: [
          { required: true, message: '请选择客户', trigger: 'change' },
        ],
        group_id: [
          { required: true, message: '请选择group_id', trigger: 'change' },
        ],
      },
      typeList: [
        {
          name: 'MALL',
          value: 0,
        },
        {
          name: '停车场',
          value: 1,
        },
      ],
    };
  },
  computed: {
    filterFloors() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.form.floors.sort((a, b) => (a.sort_index - b.sort_index)).filter(item => item.is_delete === 0);
    },
  },
  created() {
    const { form } = this;
    const { id } = form;
    if (id !== '') {
      // 编辑
      this.getDetail(id);
      this.getGroupIdByPlaceId(id);
    }
    this.getPlaces();
    this.getGroupList();
  },
  mounted() {
    this.$watch(() => this.filterFloors.length > 0, () => {
      this.handleDropRow();
    });
  },
  methods: {
    /**
     * 显示对象中的key必须是float
     */
    handleInputFloat(data, key, value = '') {
      const v = /(-|\+)?[0-9]+(\.[0-9]+)?/.exec(value);
      console.log(v);
      if (v) {
        data[key] = v[0];
      } else {
        data[key] = '';
      }
    },
    getPlaces() {
      fetchplaceList({
        page: 1,
        size: 100000,
      }).then((res) => {
        this.places = res.data.list;
      });
    },
    handleDropRow() {
      const tbody = document.querySelector('.el-table__body tbody');
      console.log('tag', tbody);
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const [dragedFloor] = _this.form.floors.splice(oldIndex, 1);
          _this.form.floors.splice(newIndex, 0, dragedFloor);
          _this.form.floors = _this.form.floors.map((item, index) => {
            item.sort_index = index + 1;
            return item;
          });
          const changedFloors = _this.form.floors;
          _this.form.floors = [];
          _this.$nextTick(() => {
            _this.form.floors = changedFloors;
          });
        },
      });
    },
    async getDetail(id) {
      const { data: placeData } = await getPlace({ id });
      this.form = { ...this.form, ...placeData };
      const { data: floorData } = await getAllFloors({ place_id: id, order: 'sort_index' });
      this.form.floors = floorData.map((item, index) => {
        if (!item.sort_index) {
          item.sort_index = index + 1;
        }
        return item;
      });
    },
    handleInsert(copyFloor) {
      const floor = copyFloor || this.floor;
      const emptyFloor = { ...floor, editable: true };
      emptyFloor.sort_index = this.form.floors.length + 1;
      this.form.floors.push(emptyFloor);
    },
    handleDelete(index, row) {
      if (row.id) {
        // 数据库中的数据执行软删除
        this.$set(row, 'is_delete', 1);
      } else {
        // 用户此次新增的数据直接删除
        this.form.floors.splice(index, 1);
      }
    },
    handleUpdateVR(index, row) {
      const { id: place_id } = this.form;
      const { vr_id, id: floor_id } = row;
      if (!vr_id) {
        this.$message.warning('需要填写vr_id');
        return;
      }
      updateVR({
        vr_id,
        floor_id,
        place_id,
      }).then((res) => {
        const { code } = res;
        if (code === 0) {
          this.$message.success('更新成功');
        } else {
          this.$message.error('更新失败');
        }
      }).catch(() => {
        this.$message.error('更新失败');
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return null;
        }
        if (!this.validateFloors()) {
          return this.$message.warning('楼层信息未填写完整');
        }
        console.log(this);
        this.$confirm('确认提交', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { form } = this;
          const { floors, ...place } = form;
          const params = {
            place,
            floors,
          };
          console.log(floors);
          let cmap_align = false;
          floors.forEach((e) => {
            if (JSON.stringify(e.floor_cmap_align_param) === '{}') {
              cmap_align = true;
            }
            e.theta = e.theta || 0;
            e.north = e.north || 0;
          });
          if (cmap_align) {
            this.$message.error('C端地图参数异常，请重新加载');
            return;
          }
          this.loading = true;
          bulkCreatePlace(params).then(async (res) => {
            this.loading = false;
            this.$message.success('保存成功');
            if (!this.originGroupData || this.originGroupData.group_id.length === 0) {
              // 新建场
              console.log('新建场');
              this.form.id = res.data;
              await createGroup({
                place_id: this.form.id,
                group_id: this.form.group_id,
              });
              this.syncFloorAndSite();
              this.$router.push({ name: 'place.list' });
            } else {
              // 更新场
              console.log('更新场');
              await updateGroup({
                id: this.originGroupData.id,
                place_id: this.form.id,
                group_id: this.form.group_id,
              });
              this.syncFloorAndSite();
              this.$router.push({ name: 'place.list' });
            }
          }).catch(() => {
            this.loading = false;
          });
        });
        return null;
      });
    },
    syncFloorAndSite() {
      const { floors, id: place_id } = this.form;
      const sites = floors.filter(i => i.is_delete !== 1).map(({
        parking_site_id = '',
        parking_floor_name = '',
        id: floor_id,
      }) => ({
        parking_site_id,
        parking_floor_name,
        floor_id,
        place_id,
      }));
      syncFloorAndSite({ list: sites, place_id });
    },
    handleCopy() {
      if (!this.sourcePlaceId) {
        this.$message.warning('请选择要复制的场');
        return;
      }
      getPlacesInfo({ place_id: this.sourcePlaceId }).then((res) => {
        res.data[0].floors.forEach((floor) => {
          const { id: ignore, ...rest } = floor;
          this.handleInsert(rest);
        });
      });
    },
    validateFloors() {
      // 仅校验未删除的
      const { filterFloors } = this;
      let valid = true;
      filterFloors.forEach((floor) => {
        if (!floor.name || !floor.floor) {
          valid = false;
        }
      });
      return valid;
    },
    async getGroupList() {
      const { data } = await getGroupList();
      const options = data.map(d => d.group_id).reduce((list, cur) => ([...list, ...cur]), []);
      this.groupOptions = [...new Set(options)];
    },
    async getGroupIdByPlaceId(id) {
      const { data: [group] } = await getGroupIdByPlaceId(id);
      if (group) {
        this.form.group_id = group.group_id;
        this.originGroupData = group;
      }
    },
    async maptrans(type = 0) {
      this.$confirm('确认转换', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async (e) => {
        let url = `/bmap/convert/getFloorData?place_id=${this.form.id}&update=1&from=${type}`;
        if (type === 'data') {
          url = `/convert-api/old2editor?place_id=${this.form.id}`;
        }
        const { data } = await Axios.get(url);
        if (data.data) {
          this.$message.success('转换完成');
        } else {
          this.$message.error(`转换异常;${data.error_msg}`);
        }
      }).catch((e) => {
        console.log(e);
      });
      // Axios.get(`/convert-api/map_data?place_id=${this.form.id}&update=true&from=${type}`);
    },
  },
};
</script>
<style lang="less" scoped>
.place {
  .form{
    &__item {
      &--input {
        width: 275px;
      }
      &--textarea {
        width: 600px;
      }
    }
  }
  .table{
    &__item {
      &--switch {
        margin-right: 20px;
      }
      &&--btn {
        margin-right: 20px;
      }
    }
    .mesh_id {
      font-size: 12px;
    }
  }
}
</style>
